import { Card, CardContent, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CustomTooltip } from "components/disw";
import React from "react";

const useStyles = makeStyles(theme => ({
  card: {
    backgroundColor: "#ffffff",
    border: "1px solid #00000026",
    borderRadius: 3,
    padding: theme.spacing(2),
    boxShadow: "0px 1px 2px 0px #0000004D",
    width: "100%",
    maxWidth: 667,
    margin: "0 auto",
    boxSizing: "border-box",
    // Card is overflow:hidden, so as a flex child of the shell it would shrink and clip instead of scrolling
    flexShrink: 0,
    "& > :last-child": {
      paddingBottom: "0px !important"
    }
  },
  content: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3)
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  title: {
    fontFamily: "Segoe UI",
    fontWeight: 700,
    fontSize: "14.4px",
    lineHeight: "19px",
    color: "#1E1E1E",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingLeft: 16
  }
}));

/** Card layout of the data source detail pages, in the style of the service product details. */
export default function DetailCard({
  title,
  badge,
  children,
  "data-testid": dataTestId
}: {
  title: string;
  /** Shown at the top right, like the status of a service product */
  badge?: React.ReactNode;
  children: React.ReactNode;
  "data-testid"?: string;
}) {
  const classes = useStyles();
  return (
    <Card variant="outlined" className={classes.card} data-testid={dataTestId}>
      <CardContent className={classes.content}>
        <div className={classes.header}>
          <CustomTooltip title={title}>
            <Typography component="div" className={classes.title}>
              {title}
            </Typography>
          </CustomTooltip>
          {badge}
        </div>
        {children}
      </CardContent>
    </Card>
  );
}
